import { UseQueryStateResult } from '@reduxjs/toolkit/dist/query/react/buildHooks.d'
import { createApi } from '@reduxjs/toolkit/query/react'

import { ApiResponse } from '@api/types/api-response.type'

import baseQueryInterceptor from './base-query-interceptor'

export enum GeneralExternalLinkModelTypes {
  BLOCK = 'block',
  FLOORPLAN = 'floorplan',
  PRECINCT = 'precinct',
  STAGE = 'stage',
}

export interface GeneralAllocation {
  modelId: string
  modelType: string
  name: string
}

export interface GeneralExternalLink {
  id?: string
  label: string
  linkUrl: string
  generalAllocations: Array<GeneralAllocation>
}

interface GeneralExternalLinkResponse {
  data: GeneralExternalLink[]
}

interface GeneralExternalLinkQueryResult {
  generalExternalLinks: GeneralExternalLink[]
  isLoaded: boolean
  isError: boolean
  isFetching: boolean
}

interface GetGeneralExternalLinksParams {
  projectName: string
  modelType: string
  label: string
  block?: string
  precinct?: string
}

export const generalExternalLinksApi = createApi({
  reducerPath: 'generalExternalLinksApi',
  baseQuery: baseQueryInterceptor,
  endpoints: (builder) => ({
    getGeneralExternalLinksByStock: builder.query<
      ApiResponse<GeneralExternalLinkResponse>,
      GetGeneralExternalLinksParams
    >({
      query: ({
        projectName,
        modelType,
        label,
        block,
        precinct,
      }: GetGeneralExternalLinksParams) => ({
        url: `/v3/${projectName}/general-external-links/allocation/${label}/type/${modelType}`,
        method: 'get',
        params: {
          ...(!!block && { block }),
          ...(!!precinct && { precinct }),
        },
      }),
    }),
  }),
})

export const selectFromResult = ({
  data,
  isLoading,
  isError,
  isFetching,
}: UseQueryStateResult<any, any>): GeneralExternalLinkQueryResult => ({
  generalExternalLinks: data?.data || {},
  isLoaded: !isLoading,
  isError,
  isFetching,
})

export const { useGetGeneralExternalLinksByStockQuery } =
  generalExternalLinksApi
